import {createContext} from 'react'

import type {AddNotification, NotificationsContext as ContextType} from './types'

export const NotificationsContext = createContext<ContextType>(null)
const globalContextKey_UNSAFE = Symbol('notifications-context')

type NotificationsProviderProps = {
  value: ContextType
  children: React.ReactNode
}

export const NotificationsProvider = ({value, children}: NotificationsProviderProps) => {
  // @ts-expect-error у типа window нет такого ключа, да в общем-то и не должно быть в типах, скрываем как можем
  window[globalContextKey_UNSAFE] = value
  return <NotificationsContext.Provider value={value}>{children}</NotificationsContext.Provider>
}

// TODO Убрать в https://st.yandex-team.ru/CARGODEV-20406
/** @deprecated нужно для миграции со старых нотификаций, которые можно было использовать в сагах. В новом коде настоятельно рекомендуется использовать `useAddNotification` из этого же файла. */
export const addNotification_UNSAFE: AddNotification = (...args) => {
  // @ts-expect-error у типа window нет такого ключа, да в общем-то и не должно быть в типах, скрываем как можем
  window[globalContextKey_UNSAFE](...args)
}
